module.exports = __webpack_public_path__ + "static/media/2020-12-07 project-clio.a9d41731.md";